module.exports = __webpack_public_path__ + "img/social-media-bg-small.4c74de69.webp";